<script setup>
// NOTICE: KAPTION-INTEGRATION - WhatsApp agent signature position selector (off/top/bottom)
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
// NOTICE: KAPTION-INTEGRATION - Client-managed feature permission layer
import { useFeaturePermissions } from 'dashboard/composables/useFeaturePermissions';
import SectionLayout from './SectionLayout.vue';

const { t } = useI18n();
// NOTICE: KAPTION-INTEGRATION - feature-permissions.REPLY_BOX.5
const { canUseFeature } = useFeaturePermissions();
const position = ref('off');

const { currentAccount, updateAccount } = useAccount();

const options = [
  {
    value: 'off',
    label: 'GENERAL_SETTINGS.FORM.WHATSAPP_AGENT_SIGNATURE.OPTIONS.OFF',
  },
  {
    value: 'top',
    label: 'GENERAL_SETTINGS.FORM.WHATSAPP_AGENT_SIGNATURE.OPTIONS.TOP',
  },
  {
    value: 'bottom',
    label: 'GENERAL_SETTINGS.FORM.WHATSAPP_AGENT_SIGNATURE.OPTIONS.BOTTOM',
  },
];

watch(
  currentAccount,
  () => {
    const val = currentAccount.value?.settings?.whatsapp_agent_signature;
    // Handle legacy boolean values: true → 'bottom', false/null → 'off'
    if (val === true) {
      position.value = 'bottom';
    } else if (val && val !== 'false') {
      position.value = val;
    } else {
      position.value = 'off';
    }
  },
  { deep: true, immediate: true }
);

const updatePosition = async event => {
  const newValue = event.target.value;
  position.value = newValue;
  try {
    await updateAccount({ whatsapp_agent_signature: newValue });
    useAlert(t('GENERAL_SETTINGS.FORM.WHATSAPP_AGENT_SIGNATURE.API.SUCCESS'));
  } catch (error) {
    useAlert(t('GENERAL_SETTINGS.FORM.WHATSAPP_AGENT_SIGNATURE.API.ERROR'));
  }
};
</script>

<!-- feature-permissions.REPLY_BOX.5 -->
<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <SectionLayout
    v-if="canUseFeature('agent_signature')"
    :title="t('GENERAL_SETTINGS.FORM.WHATSAPP_AGENT_SIGNATURE.TITLE')"
    :description="t('GENERAL_SETTINGS.FORM.WHATSAPP_AGENT_SIGNATURE.NOTE')"
    with-border
  >
    <template #headerActions>
      <div class="flex justify-end">
        <select
          :value="position"
          class="mb-0 text-sm rounded-md border border-n-weak bg-n-solid-2 px-2 py-1.5 text-n-slate-12"
          @change="updatePosition"
        >
          <option v-for="opt in options" :key="opt.value" :value="opt.value">
            {{ t(opt.label) }}
          </option>
        </select>
      </div>
    </template>
  </SectionLayout>
</template>
